@if (scannerEnabled) {
  <div class="relative">
    <!-- Camera Selector - this won't be just a basic <select> forever, just using a super basic/compact setup for the initial POC. -->
    <div>
      <label class="text-title-medium pr-2" for="deviceSelect">Camera:</label>
      <select id="deviceSelect" (change)="onCameraChange($event)">
        @for (cam of cameras; track $index) {
          <option class="text-body-medium" [value]="cam.deviceId">{{ cam.label || 'Unknown Camera' }}</option>
        }
      </select>
    </div>

    <!-- Scanner Camera View -->
    <zxing-scanner [formats]="acceptedFormats" [enable]="isCameraSelected" [device]="currentCamera" (scanSuccess)="onBarcodeScanned($event)"
                   (camerasFound)="onCamerasDetected($event)" (camerasNotFound)="onCamerasDetected([])" (scanError)="onError($event)" class="mt-2 mb-4"/>

    <!-- In-Camera Hint -->
    <div class="py-1 px-2 text-[#fff] bg-[rgba(0,0,0,0.45)] rounded-md absolute bottom-4 justify-self-center pointer-events-none">
      Keep camera steady, scan will complete automatically when barcode is in focus.
    </div>

    <!-- Close Button (Camera also auto-closes after a successful scan) -->
    <button class="p-[0.35rem] pb-0 text-[#fff] bg-[rgba(0,0,0,0.45)] rounded-full absolute top-12 right-4" (click)="closeScanner()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}

<!-- Input Form -->
<div class="w-full flex flex-row items-center gap-8">
  <mx-input-form-field fieldName="barcode" overrideLabel="Item Lookup" placeholder="Enter Item or Scan Barcode" [formGroup]="scannerForm"
                       class="grow no-bottom-margin"/>
  <button mat-button color="primary" (click)="activateMobileScanner()" class="-ms-3">Mobile Scan</button>
</div>
